(function ($) {
  $(function () {
    $.widget("zpd.paging", {
      options: {
        limit: 5,
        rowDisplayStyle: "block",
        activePage: 0,
        rows: [],
        visiblePages: 8, // Number of visible page links at a time
      },
      _create: function () {
        var rows = $("tbody", this.element).children();
        this.options.rows = rows;
        this.options.rowDisplayStyle = rows.css("display");
        this.nav = this._getNavBar();
        this.element.after(this.nav);
        this.showPage(0);
      },
      _getNavBar: function () {
        var nav = $("<div>", { class: "paging-nav" });
        this._updateNavBar(nav);
        return nav;
      },
      _updateNavBar: function (nav) {
        nav.empty();
        var rows = this.options.rows;
        var totalPages = Math.ceil(rows.length / this.options.limit);
        var visiblePages = this.options.visiblePages;
        var activePage = this.options.activePage;

        // Calculate start and end page
        var startPage = Math.max(0, activePage - Math.floor(visiblePages / 2));
        var endPage = Math.min(totalPages, startPage + visiblePages);

        // Adjust if near the start or end of the list
        if (startPage > 0 && endPage - startPage < visiblePages) {
          startPage = Math.max(0, endPage - visiblePages);
        }

        // Previous button
        this._on(
          $("<a>", {
            href: "#",
            text: "<<",
            "data-direction": -1,
          }).appendTo(nav),
          { click: "pageStepHandler" }
        );

        // Page numbers
        for (var i = startPage; i < endPage; i++) {
          this._on(
            $("<a>", {
              href: "#",
              text: i + 1,
              "data-page": i,
              class: i === activePage ? "selected-page" : "",
            }).appendTo(nav),
            { click: "pageClickHandler" }
          );
        }

        // Always show the last page if it's not already in the visible range
        if (endPage < totalPages) {
          $("<span>", { text: "..." }).appendTo(nav); // Ellipsis
          this._on(
            $("<a>", {
              href: "#",
              text: totalPages,
              "data-page": totalPages - 1,
            }).appendTo(nav),
            { click: "pageClickHandler" }
          );
        }

        // Next button
        this._on(
          $("<a>", {
            href: "#",
            text: ">>",
            "data-direction": +1,
          }).appendTo(nav),
          { click: "pageStepHandler" }
        );
      },
      showPage: function (pageNum) {
        var num = pageNum * 1; // Ensure numeric
        this.options.activePage = num;
        var rows = this.options.rows;
        var limit = this.options.limit;

        for (var i = 0; i < rows.length; i++) {
          if (i >= limit * num && i < limit * (num + 1)) {
            $(rows[i]).css("display", this.options.rowDisplayStyle);
          } else {
            $(rows[i]).css("display", "none");
          }
        }

        // Update the navigation bar to reflect the active page
        this._updateNavBar(this.nav);
      },
      pageClickHandler: function (event) {
        event.preventDefault();
        var pageNum = $(event.target).attr("data-page");
        this.showPage(pageNum);
      },
      pageStepHandler: function (event) {
        event.preventDefault();
        var dir = $(event.target).attr("data-direction") * 1; // Ensure numeric
        var pageNum = this.options.activePage + dir;
        var totalPages = Math.ceil(
          this.options.rows.length / this.options.limit
        );

        if (pageNum >= 0 && pageNum < totalPages) {
          this.showPage(pageNum);
        }
      },
    });
  });
})(jQuery);
